import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'parentGroupFidelity',
    label: 'Parent Group Fidelity',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
